import React, { useEffect, useState } from "react";
import { getDatabase, ref, set } from "firebase/database";
import app from "../../../firebaseConfig";

import ProteccionAdmin from "./proteccionadmin"; 

const PantallaCodigoMesas = () => {
  const [codigo, setCodigo] = useState("");
  const [enHorarioActivo, setEnHorarioActivo] = useState(false);

  const generarCodigo = () => {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let nuevoCodigo = "";
    for (let i = 0; i < 4; i++) {
      nuevoCodigo += letras.charAt(Math.floor(Math.random() * letras.length));
    }
    return nuevoCodigo;
  };

  const guardarCodigoEnFirebase = (codigoGenerado) => {
    const db = getDatabase(app);
    const codigoRef = ref(db, "nature/Awoo/Control/CodigoMesas");
    set(codigoRef, codigoGenerado);
  };

  const actualizarCodigo = () => {
    const ahora = new Date();
    const hora = ahora.getHours();

    // Horario activo: de 4:00pm (16) hasta 3:59am (3)
    const dentroDelHorario = hora >= 9 || hora < 4;

    setEnHorarioActivo(dentroDelHorario);

    if (dentroDelHorario) {
      const nuevoCodigo = generarCodigo();
      setCodigo(nuevoCodigo);
      guardarCodigoEnFirebase(nuevoCodigo);
    }
  };

  useEffect(() => {
    actualizarCodigo(); // Generar o validar al entrar

    const intervalo = setInterval(() => {
      actualizarCodigo();
    }, 300000); // cada 5 minutos

    return () => clearInterval(intervalo);
  }, []);

  return (

    <ProteccionAdmin>

      
    <div
      style={{
        backgroundColor: "#000",
        color: "#2BF9FF",
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: enHorarioActivo ? "20vw" : "5vw",
        fontWeight: "bold",
        fontFamily: "'Verdana', sans-serif",
        textAlign: "center",
        padding: "20px",
        userSelect: "none",
      }}
    >
      {enHorarioActivo ? (
        <span style={{ textShadow: "0px 0px 20px #2BF9FF" }}>{codigo}</span>
      ) : (
        <div>
          <p style={{ color: "#fff", marginBottom: "10px" }}>
            🕒 Fuera de horario comercial
          </p>
          <p style={{ color: "#aaa" }}>
            El código estará disponible a partir de las <strong>4:00 pm</strong>.
          </p>
        </div>
      )}
    </div>
    </ProteccionAdmin>

    
  );
};

export default PantallaCodigoMesas;
